// src/types/coupons/Coupon.ts
var CouponIssuerType = /* @__PURE__ */ ((CouponIssuerType2) => {
  CouponIssuerType2["Host"] = "HOST";
  CouponIssuerType2["Admin"] = "ADMIN";
  return CouponIssuerType2;
})(CouponIssuerType || {});
var CouponDiscountType = /* @__PURE__ */ ((CouponDiscountType2) => {
  CouponDiscountType2["Percentage"] = "PERCENTAGE";
  CouponDiscountType2["Fixed"] = "FIXED";
  return CouponDiscountType2;
})(CouponDiscountType || {});
var CouponStatus = /* @__PURE__ */ ((CouponStatus2) => {
  CouponStatus2["Active"] = "ACTIVE";
  CouponStatus2["Paused"] = "PAUSED";
  CouponStatus2["Expired"] = "EXPIRED";
  return CouponStatus2;
})(CouponStatus || {});
var CouponTargetType = /* @__PURE__ */ ((CouponTargetType2) => {
  CouponTargetType2["User"] = "USER";
  CouponTargetType2["Listing"] = "LISTING";
  CouponTargetType2["Workspace"] = "WORKSPACE";
  return CouponTargetType2;
})(CouponTargetType || {});
var CouponIneligibleReason = /* @__PURE__ */ ((CouponIneligibleReason2) => {
  CouponIneligibleReason2["CurrencyMismatch"] = "COUPON_CURRENCY_MISMATCH";
  return CouponIneligibleReason2;
})(CouponIneligibleReason || {});
var CouponRedemptionStatus = /* @__PURE__ */ ((CouponRedemptionStatus2) => {
  CouponRedemptionStatus2["Reserved"] = "RESERVED";
  CouponRedemptionStatus2["Confirmed"] = "CONFIRMED";
  CouponRedemptionStatus2["Released"] = "RELEASED";
  return CouponRedemptionStatus2;
})(CouponRedemptionStatus || {});

export {
  CouponIssuerType,
  CouponDiscountType,
  CouponStatus,
  CouponTargetType,
  CouponIneligibleReason,
  CouponRedemptionStatus
};
